export default __webpack_public_path__ + "static/media/404-WEB.965983a4.svg";